const ID3V2_HEADER_BYTES = 10;
const ID3V2_FOOTER_FLAG = 0x10;

const readSynchsafeInt = (bytes: Uint8Array, offset: number): number => {
  return (
    ((bytes[offset] & 0x7f) << 21) |
    ((bytes[offset + 1] & 0x7f) << 14) |
    ((bytes[offset + 2] & 0x7f) << 7) |
    (bytes[offset + 3] & 0x7f)
  );
};

const isId3v2Header = (bytes: Uint8Array): boolean => {
  return bytes[0] === 0x49 && bytes[1] === 0x44 && bytes[2] === 0x33;
};

// Files can carry several stacked ID3v2 tags (one per editing tool); every one has to be skipped to reach the first audio frame. Returns the byte offset of that frame, 0 when the file has no tag.
export const readId3v2TotalBytes = async (audioFile: File): Promise<number> => {
  let offset = 0;

  while (true) {
    const headerBytes = new Uint8Array(
      await audioFile.slice(offset, offset + ID3V2_HEADER_BYTES).arrayBuffer()
    );
    if (
      headerBytes.length < ID3V2_HEADER_BYTES ||
      !isId3v2Header(headerBytes)
    ) {
      return offset;
    }

    const hasFooter = (headerBytes[5] & ID3V2_FOOTER_FLAG) !== 0;
    const tagBodyBytes = readSynchsafeInt(headerBytes, 6);
    offset +=
      ID3V2_HEADER_BYTES + tagBodyBytes + (hasFooter ? ID3V2_HEADER_BYTES : 0);
  }
};
